import { DataBean } from "../DataBean";

export class ProjectBeneficiary extends DataBean {
    
    


    public async getProjectBeneficiaryCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectBeneficiaryCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getProjectBeneficiaryCatalogPorPropiedadesRender(props:any,rows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectBeneficiaryCatalogPorPropiedadesRender_java.util.Map_Number", [props,rows]);
    }
  

}